// Types
import type { BaseOptions } from 'flatpickr/dist/types/options';
import type { Locale as VueI18nLocale } from 'vue-i18n';

// flatpickr locales
import { Dutch as nl } from 'flatpickr/dist/l10n/nl.js';
import { english as en } from 'flatpickr/dist/l10n/default.js';
import { French as fr } from 'flatpickr/dist/l10n/fr.js';
import { German as de } from 'flatpickr/dist/l10n/de.js';
import { Italian as it } from 'flatpickr/dist/l10n/it.js';
import { Polish as pl } from 'flatpickr/dist/l10n/pl.js';
import { Portuguese as pt } from 'flatpickr/dist/l10n/pt.js';
import { Spanish as es } from 'flatpickr/dist/l10n/es.js';

type CustomLocale = Partial<BaseOptions['locale']>;
type Locale = 'en' | 'fr' | 'es' | 'pl' | 'it' | 'de' | 'pt' | 'nl';

export function getFlatpickrLocale(locale: VueI18nLocale): CustomLocale {
  const locales = { fr, en, es, pl, it, de, pt, nl };
  const twoLetterLanguageCode = `${locale.slice(0, 2)}` as Locale;

  const obj = {} as {
    [key: string]: CustomLocale;
  };

  Object.keys(locales).forEach((key) => {
    switch (key) {
      // Formatting for all english locales
      case 'en':
        obj[key] = {
          ...locales[key],
          weekdays: {
            shorthand: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            longhand: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          },
        };
        break;

      // Locales that use lowercase month formatting
      case 'fr':
      case 'es':
      case 'pl':
      case 'it':
      case 'pt':
      case 'nl':
        obj[key] = {
          ...locales[key],
          months: {
            shorthand: locales[key].months.shorthand,
            longhand: locales[key].months.longhand.map((item) =>
              item.toLowerCase()
            ),
          },
        };
        break;
      case 'de':
        obj[key] = locales[key];
        break;
    }
  });

  return obj[twoLetterLanguageCode] || obj['en'];
}
